import {Fragment} from "react";
import {useTranslation} from "react-i18next";
import { numberFormat } from "../../utils/currencyFormatter";
export function Price({price,classNameCurrency,showZero=false}) {
    const {t: trans} = useTranslation(["common"]);
    

    return (
        <Fragment>
            {numberFormat(price,classNameCurrency,showZero)}
        </Fragment>
    );
}

